module.exports = __webpack_public_path__ + "static/img/demo-header_768.de604ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo-header_768.png
// module id = Q0Hg
// module chunks = 0